import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import {
    MenuActionButtonItem,
    MenuActionsButtonComponent,
} from '@interacta-shared/ui-common';
import { getAIConvoHistoryTitle } from '@modules/ai-convo/helpers/ai-convo-panel.utils';
import { AIConvoHistoryItem } from '@modules/ai-convo/models/ai-convo-history.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-ai-convo-history-list-item',
    templateUrl: './ai-convo-history-list-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MenuActionsButtonComponent, TranslatePipe],
})
export class AIConvoHistoryListItemComponent {
    readonly item = input.required<AIConvoHistoryItem>();
    readonly itemClick = output<AIConvoHistoryItem>();
    readonly renameClick = output<AIConvoHistoryItem>();
    readonly deleteClick = output<AIConvoHistoryItem>();

    readonly displayTitle = computed(() => getAIConvoHistoryTitle(this.item()));

    readonly menuActionItems: MenuActionButtonItem<AIConvoHistoryItem>[] = [
        {
            type: 'button',
            label: 'BUTTON.LABEL_BUTTON_RENAME',
            icon: 'pen-pad',
            click: (item) => this.renameClick.emit(item),
        },
        {
            type: 'button',
            label: 'BUTTON.LABEL_BUTTON_DELETE',
            icon: 'trash-bin',
            click: (item) => this.deleteClick.emit(item),
        },
    ];
}
